<template>
	<section>
		<img v-lazy="imgUrl" class="topbanner">
		<div class="tips">
			<div class="tip-icon">使用帮助</div>
			<ul class="tip-detail">
				<li>1. 请选择所吃食物</li>
				<li>2. 所有食物需先选择食物类别</li>
				<li>3. 所吃食物可以选择多项</li>
				<li>4. 计算出所有食物产生的总热量</li>
				<li>5. 计算某一种运动方式所需时间</li>
			</ul>
		</div>
		<router-link to="/fillform" class="calculate-link">开始计算一日所需能量</router-link>
	</section>
</template>
<script>
export default {
  data () {
    return {
     imgUrl: '/static/topbanner3.png' // String
    }
  },
  head: {
		title: function () {
			return {
				inner: '一日所需能量',
				separator: ' ', 
        		complement: ' '
			}
		}
	},
	created(){
		if(jumpornot){
			if(localStorage.openid){

			}else if(this.$route.query.openid){
				localStorage.openid = this.$route.query.openid
			}else{
				window.location.href = jump_base + 'power'
			}
		}
	}

}
</script>


// WEBPACK FOOTER //
// dayneedindex.vue?684a182c